export default __webpack_public_path__ + "static/media/alert.f3a3d646.jpg";